document.addEventListener("DOMContentLoaded", () => {

  ///////////////Mapeo de imagenes
  const IMAGE_MAP = new Map([
    ['cap_total2',                    'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_20.png?v=1761239150'],
    ['cap_ultra',                     'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_21.png?v=1761239191'],
    ['cap_pro2',                      'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_18.png?v=1761238221'],
    ['cap_plus2',                     'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_19.png?v=1761239101'],
    ['cap_stand',                     'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/stand_2.png?v=1769024905'],
    ['cap_box+cap_stand',             'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/stand_box_22b27220-7b74-4dee-affe-18a2e0df06a4.png?v=1769024905'],
    ['cap_printer+cap_stand',         'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/stand_printer_cd942cf9-299d-4bbd-97ed-0be6094c3d5c.png?v=1769024906'],
    ['cap_box+cap_printer+cap_stand', 'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/stand_printer_box_6d34a037-5dc4-405d-8a5c-886f74dd4f86.png?v=1769024905'],
    ['cap_box+cap_total2',            'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_22.png?v=1761244545'],
    ['cap_box+cap_ultra',             'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_23.png?v=1761244600'],
    ['cap_printer+cap_pro2',          'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_24.png?v=1761244729'],
    ['cap_box+cap_pro2',              'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_25.png?v=1761244782'],
    ['cap_box+cap_printer+cap_pro2',  'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_26.png?v=1761244835'],
    ['cap_plus2+cap_printer',         'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_27.png?v=1761244964'],
    ['cap_box+cap_plus2',             'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_28.png?v=1761244999'],
    ['cap_box+cap_plus2+cap_printer', 'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_29.png?v=1761245053'],
    ['cap_total3',                    'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_1_3407f1c4-f572-4b77-ad01-c18fb98e5024.png?v=1770235327'],
    ['cap_box+cap_total3',            'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image.jpg?v=1770235327']
  ]);


  const section = document.querySelector('.arma_tu_kit');
  const kit_discount = section.dataset.descuento;
  const kit_discount_code = section.dataset.codigo;

  function makeKey(ids) {
    return [...new Set(ids)].sort().join('+');
  }

  function getImageUrl(...maybeArray) {
    const ids = Array.isArray(maybeArray[0]) ? maybeArray[0] : maybeArray;
    const key = makeKey(ids);
    return IMAGE_MAP.get(key) ?? null;
  }
  /////////////



    
    function withWidth(url, w) {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}width=${w}`;
    }

    // Construye un srcset con varias anchuras
    function buildSrcset(url, widths = []) {
    return widths.map(w => `${withWidth(url, w)} ${w}w`).join(', ');
    }

  function set_total() {

    

    const activos = document.querySelectorAll('.kit_capsula.activo');
    let total = 0;

    const cantidadActivos = activos.length;

    activos.forEach(div => {
      const precioStr = div.getAttribute('data-precio');
      if (!precioStr) return;

      const num = parseFloat(precioStr.replace(/[^0-9.]/g, '').replace(',', ''));
      if (isNaN(num)) return;

      // Si hay más de un activo y es un kit_device => aplicar descuento
      if (div.classList.contains('kit_device') && cantidadActivos > 1) {
        total += num * (1- (kit_discount/100));
      } else {
        total += num;
      }
    });

    const totalFormateado =
      '$ ' +
      total.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

    const destino = document.getElementById('kit_total_pagar');
    if (destino) {
      destino.textContent = totalFormateado;
      destino.classList.remove("total_disabled");
    }
  }



function set_btn_comprar() {
  const activos = document.querySelectorAll('.kit_capsula.activo');
  const variants = [];

  activos.forEach(div => {
    const variant = div.getAttribute('data-variant_id');
    if (variant) variants.push(`${variant}:1`); // agrega cantidad 1
  });

  const destino = document.getElementById('btn_kit_comprar');

  if (destino) {
    if (variants.length > 0) {
      // arma el link de checkout (ajusta dominio)
      const shopDomain = 'https://shop.clip.mx'; 
      const link = `${shopDomain}/cart/${variants.join(',')}`;
      destino.href = link+"?discount="+kit_discount_code;
      destino.removeAttribute('disabled');
      destino.classList.remove("btn_disabled");
    } else {
      destino.href = '#';
      destino.setAttribute('disabled', true);
    }
  }
}


  ///////////////setea la imagen del kit
function set_image() {
  const activos = document.querySelectorAll('.kit_capsula.activo');
  const ids = Array.from(activos).map(el => el.id);
  const foto = document.querySelector('.kit_foto_principal');

  const foto_resumen = document.querySelector('.kit_resumen_image');

  const defaultUrl = 'https://cdn.shopify.com/s/files/1/0776/4174/4683/files/Image_31.png?v=1761838211';
  const foundUrl = ids.length > 0 ? getImageUrl(ids) : null;
  const baseUrl = foundUrl || defaultUrl;

  const widths = [479, 642, 812, 936];

  if (foto) {
    
    foto.src = withWidth(baseUrl, Math.max(...widths));
    foto.srcset = buildSrcset(baseUrl, widths);
    foto.sizes = '(max-width: 768px) 479px, 936px';
    foto.decoding = 'async';
    }
  
  if (foto_resumen) {
    foto_resumen.src = withWidth(baseUrl, Math.max(...widths));
    foto_resumen.srcset = buildSrcset(baseUrl, widths);
    foto_resumen.sizes = '(max-width: 768px) 479px, 936px';
    foto_resumen.decoding = 'async';
    }
}

  ////setea la clase activo en los devices
  document.querySelectorAll('.kit_capsula.kit_device').forEach(capsula => {
    capsula.addEventListener('click', e => {
      
      const id = e.currentTarget.id;
      const cap_printer = document.getElementById('cap_printer');
      const cap_box = document.getElementById('cap_box');
      cap_box.classList.remove('inactivo');

      const msg_impresora_integrada = document.getElementById('msg_impresora_integrada');

      

      
      document.getElementById("kit_resumen_default_text").innerHTML="";

      

      if (id === 'cap_total2' || id === 'cap_ultra' || id === 'cap_stand' || id === 'cap_total3' ) {

        cap_printer.classList.remove('activo');
        cap_printer.classList.add('inactivo');
        msg_impresora_integrada.style.display="block";

        if (id === 'cap_total2'){msg_impresora_integrada.innerHTML="El Clip Total 2 que elegiste tiene impresora integrada 🙂";}
        else if (id === 'cap_total3'){msg_impresora_integrada.innerHTML="El Clip Total 3 que elegiste tiene impresora integrada 🙂";}
        else if (id === 'cap_stand'){msg_impresora_integrada.innerHTML="El Clip Stand que elegiste tiene impresora integrada 🙂";}
        else{msg_impresora_integrada.innerHTML="El Clip Ultra que elegiste tiene impresora integrada 🙂";}
        
        document.getElementById("kit_resumen_printer_nombre").innerHTML="";
        document.getElementById("kit_resumen_printer_precio").innerHTML="";
        

      } else {
        msg_impresora_integrada.style.display="none";
        cap_printer.classList.remove('inactivo');
      }

      //set en el identificador id=kit_resumen_title_prod el nombre del producto. 
      document.getElementById("kit_resumen_title_prod").innerHTML=document.getElementById(id).querySelector(".kit_nombre_prod").innerHTML;

      //set el nombre y precio en el resumen
      document.getElementById("kit_resumen_device_nombre").innerHTML=document.getElementById(id).getAttribute("data-nombre");

/*
      const precioTexto = document.getElementById(id).getAttribute("data-precio");
      const precioNumero = parseFloat(precioTexto.replace(/[^0-9.-]+/g, ''));
      const precioDescuento = precioNumero * 0.9;
      const formatear = (valor) =>
        "$ " + valor.toLocaleString("es-MX", { minimumFractionDigits: 0 });
      document.getElementById("kit_resumen_device_precio_old").innerHTML = formatear(precioNumero);
      document.getElementById("kit_resumen_device_precio").innerHTML = formatear(precioDescuento);      
*/      

      // id = id del elemento .kit_device clickeado
      const elDevice = document.getElementById(id);
      if (!elDevice) return;

      const precioTexto = elDevice.getAttribute("data-precio");
      if (!precioTexto) return;

      const precioNumero = parseFloat(precioTexto.replace(/[^0-9.-]+/g, ''));
      if (!Number.isFinite(precioNumero)) return;

      const formatear = (valor) =>
        "$ " + valor.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      // Detectar si hay impresora o box activos además del device
      const activos = document.querySelectorAll('.kit_capsula.activo');
      const hayPrinter = Array.from(activos).some(el => el.classList.contains('kit_printer'));
      const hayBox = Array.from(activos).some(el => el.classList.contains('kit_box'));
      const aplicaDescuento = hayPrinter || hayBox;

      // Referencias a los contenedores de precio
      const elOld = document.getElementById("kit_resumen_device_precio_old");
      const elFinal = document.getElementById("kit_resumen_device_precio");
      if (!elOld || !elFinal) return;

      if (aplicaDescuento) {
        // Mostrar precio original y precio con 10% de descuento
        const precioDescuento = precioNumero * (1 - (kit_discount/100));
        //elOld.style.display = "block";
        elOld.style.display = "none";
        elOld.innerHTML = formatear(precioNumero);
        elFinal.innerHTML = formatear(precioDescuento);

        document.getElementById("precio_especial_msg").style.display="block";
      } else {
        // Solo device activo -> sin descuento y ocultar precio old
        elOld.style.display = "none";
        elOld.innerHTML = ""; // opcional
        elFinal.innerHTML = formatear(precioNumero);
        document.getElementById("precio_especial_msg").style.display="none";
      }



      document.querySelectorAll('.kit_capsula.kit_device.activo')
        .forEach(el => el.classList.remove('activo'));
      e.currentTarget.classList.add('activo');
      
      set_total();
      set_btn_comprar()
      set_image();
    });
  });


  ////setea la clase activo en printer
  document.querySelectorAll('.kit_capsula.kit_printer').forEach(capsula => {
    capsula.addEventListener('click', e => {
      const el = e.currentTarget;
      if (el.classList.contains('inactivo')) return;
      el.classList.toggle('activo');

      document.getElementById("kit_resumen_default_text").innerHTML="";
      

      //set el nombre y precio en el resumen
      if (el.classList.contains('activo')){
        document.getElementById("kit_resumen_printer_nombre").innerHTML=el.getAttribute("data-nombre");
        document.getElementById("kit_resumen_printer_precio").innerHTML=el.getAttribute("data-precio");
      }
      else{
        document.getElementById("kit_resumen_printer_nombre").innerHTML="";
        document.getElementById("kit_resumen_printer_precio").innerHTML="";
      }
      

      
      set_btn_comprar()
      set_image();
      document.querySelectorAll('.kit_capsula.kit_device').forEach(div => {
        if (div.classList.contains('activo')) {
          div.click(); // simula el clic
        }
      });

      set_total();


    });
  });


  ////setea la clase activo en box
  document.querySelectorAll('.kit_capsula.kit_box').forEach(capsula => {
    capsula.addEventListener('click', e => {

      const el = e.currentTarget;
      if (el.classList.contains('inactivo')) return; // ✅ BLOQUEO REAL

      el.classList.toggle('activo');
      document.getElementById("kit_resumen_default_text").innerHTML="";


      //set el nombre y precio en el resumen
      if (el.classList.contains('activo')){
        document.getElementById("kit_resumen_box_nombre").innerHTML=el.getAttribute("data-nombre");
        document.getElementById("kit_resumen_box_precio").innerHTML=el.getAttribute("data-precio");
      }
      else{
        document.getElementById("kit_resumen_box_nombre").innerHTML="";
        document.getElementById("kit_resumen_box_precio").innerHTML="";
      }

      
      set_btn_comprar()
      set_image();
      document.querySelectorAll('.kit_capsula.kit_device').forEach(div => {
        if (div.classList.contains('activo')) {
          div.click(); // simula el clic 
        }
      });

      set_total();

    });
  });





  ///////////////pone primeras letras en gris	
    document.querySelectorAll('.kit_nombre_prod').forEach(el => {
      const text = el.textContent.trim();
      if (text.length > 4) {
        const firstPart = text.slice(0, 4);
        const rest = text.slice(4);
        el.innerHTML = `<span class="kit_nombre_gris">${firstPart}</span>${rest}`;
      }
    });
   /////////////
       document.querySelectorAll('.kit_resumen_title_prod').forEach(el => {
      const text = el.textContent.trim();
      if (text.length > 4) {
        const firstPart = text.slice(0, 4);
        const rest = text.slice(4);
        el.innerHTML = `<span class="kit_nombre_gris">${firstPart}</span>${rest}`;
      }
    });
   /////////////


   



});
